const UVTValue = 38000;

const retefuenteLabelValueList = [
  //   { value: 2365, label: 'RETENCION EN LA FUENTE' },
  //   { value: 236505, label: 'SALARIOS Y PAGOS LABORALES' },
  //   { value: 236510, label: 'DIVIDENDOS Y/O PARTICIPACIONES' },
  //   { value: 23651001, label: 'DIVIDENDOS Y/O PARTICIPACIONES NO RESIDENTES' },
  //   { value: 236515, label: 'HONORARIOS' },
  { value: 23651501, label: 'HONORARIOS NO DECLARANTES (10%)', percent: 0.1, minBase: 27 * UVTValue },
  { value: 23651502, label: 'HONORARIOS DECLARANTES (11%)', percent: 0.11, minBase: 27 * UVTValue },
  { value: 23651503, label: 'HONORARIOS DIFERIDOS (11%)', percent: 0.11, minBase: 27 * UVTValue },
  { value: 23651504, label: 'HONORARIOS DIFERIDOS (10%)', percent: 0.1, minBase: 27 * UVTValue },
  //   { value: 236520, label: 'COMISIONES' },
  { value: 23652001, label: 'COMISIONES NO DECLARANTES (10%)', percent: 0.1, minBase: 27 * UVTValue },
  { value: 23652002, label: 'COMISIONES DECLARANTES (11%)', percent: 0.11, minBase: 27 * UVTValue },
  { value: 23652003, label: 'COMISIONES DIFERIDOS NO DECLARANTES (10%)', percent: 0.1, minBase: 27 * UVTValue },
  { value: 23652004, label: 'COMISIONES DIFERIDOS DECLARANTES (11%)', percent: 0.11, minBase: 27 * UVTValue },
  //   { value: 236525, label: 'SERVICIOS' },
  { value: 23652501, label: 'SERVICIOS GENERALES NO DECLARANTES (6%)', percent: 0.06, minBase: 27 * UVTValue },
  { value: 23652502, label: 'SERVICIOS GENERALES DECLARANTES (4%)', percent: 0.04, minBase: 27 * UVTValue },
  { value: 23652503, label: 'SERVICIOS TRANSPORTE DE CARGA (1%)', percent: 0.01, minBase: 27 * UVTValue },
  { value: 23652504, label: 'SERVICIOS EMPRESAS TEMPORALES DE EMPLEO (1%)', percent: 0.01, minBase: 27 * UVTValue },
  { value: 23652505, label: 'SERVICIOS DE VIGILANCIA Y ASEO (2%)', percent: 0.02, minBase: 27 * UVTValue },
  { value: 23652506, label: 'SERVICIO HOTELES Y RESTAURANTES (3.5%)', percent: 0.035, minBase: 27 * UVTValue },
  //   { value: 23652507, label: 'SERVICIO DE TRANSPORTE PASAJEROS AEREO Y MARITIMO' },
  { value: 23652508, label: 'SERVICIO DE TRANSPORTE PASAJEROS POR CARRETERA (3.5%)', percent: 0.035, minBase: 27 * UVTValue },
  { value: 23652509, label: 'RETENCION EN LA FUENTE SERVICIOS MANO DE OBRA CONSTRUCCION (1%)', percent: 0.01, minBase: 27 * UVTValue },
  { value: 23652510, label: 'SERVICIOS GENERALES DIFERIDOS NO DECLARANTES (6%)', percent: 0.06, minBase: 27 * UVTValue },
  { value: 23652511, label: 'SERVICIOS GENERALES DIFERIDOS  DECLARANTES (4%)', percent: 0.04, minBase: 27 * UVTValue },
  //   { value: 236530, label: 'ARRENDAMIENTOS' },
  { value: 23653001, label: 'ARRENDAMIENTO BIENES MUEBLES (4%)', percent: 0.04, minBase: 27 * UVTValue },
  { value: 23653002, label: 'ARRENDAMIENTO BIENES INMUEBLES (3.5%)', percent: 0.035, minBase: 27 * UVTValue },
  { value: 23653003, label: 'ARRENDAMIENTOS INMUEBLES DIFERIDOS (3.5%)', percent: 0.035, minBase: 27 * UVTValue },
  { value: 23653004, label: 'ARRENDAMIENTOS MUEBLES DIFERIDOS (4%)', percent: 0.04, minBase: 27 * UVTValue },
  //   { value: 236535, label: 'RENDIMIENTOS FINANCIEROS' },
  //   { value: 236540, label: 'COMPRAS' },
  { value: 23654001, label: 'RETENCION POR COMPRAS (DECLARANTES) (2.5%)', percent: 0.025, minBase: 27 * UVTValue },
  { value: 23654003, label: 'COMPRA DE COMBUSTIBLES Y DERIVADOS DEL PETROLEO (0,1%)', percent: 0.001, minBase: 27 * UVTValue },
  //   { value: 23654004, label: 'RETENCION POR COMPRAS DIFERIDOS' },
  { value: 23654005, label: 'RETENCION POR COMPRAS (NO DECLARANTES) (3.5%)', percent: 0.035, minBase: 27 * UVTValue }
  //   { value: 236545, label: 'LOTERIAS, RIFAS, APUESTAS Y SIMILARES' },
  //   { value: 236550, label: 'POR PAGOS AL EXTERIOR' },
  //   { value: 236555, label: 'POR INGRESOS OBTENIDOS EN EL EXTERIOR' }
];

const reteicaLabelValueList = [
  //   { value: 2368, label: 'IMPUESTO DE INDUSTRIA Y COMERCIO RETENIDO' },
  //   { value: 236801, label: 'ICA RETENIDO' },
  { value: 23680101, label: 'RETENCION DE ICA COMPRAS (11,04%)', percent: 0.1104, minBase: 27 * UVTValue },
  { value: 23680102, label: 'RETENCION DE ICA SERVICIOS (9,66%)', percent: 0.0966, minBase: 27 * UVTValue },
  { value: 23680103, label: 'RETENCION DE ICA HONORARIOS O CONSULTORIA (7,66%)', percent: 0.0766, minBase: 27 * UVTValue },
  { value: 23680104, label: 'RETENCION DE ICA POR SERVICIO DE TRANSPORTE (4,14%)', percent: 0.0414, minBase: 27 * UVTValue },
  { value: 23680105, label: 'RETENCION DE ICA POR SERVICIOS DE CONSTRUCCION (7,12%)', percent: 0.0712, minBase: 27 * UVTValue },
  {
    value: 23680106,
    label: 'RETENCION POR ACTIVIDADES DE TELECOMUNICACION ALAMBRICAS E INALAMBRICAS (9,98%)',
    percent: 0.0998,
    minBase: 27 * UVTValue
  }
  //   { value: 23680107, label: 'RETENCION DE ICA POR COMISIONES' }
];

const reteivaLabelValueList = [
  // { value: 2367, label: 'IMPUESTO A LAS VENTAS RETENIDO' },
  { value: 236701, label: 'IMPUESTO A LAS VENTAS RETENIDO (15%)', percent: 0.15, minBase: 27 * UVTValue }
];

exports.retefuenteLabelValueList = retefuenteLabelValueList;
exports.reteicaLabelValueList = reteicaLabelValueList;
exports.reteivaLabelValueList = reteivaLabelValueList;
